import { StanjeRobeStockOutRecord } from '../types';

export type StanjeRobeShipmentGroup = {
  key: string;
  shipmentId?: string;
  outDate: string;
  customerName: string;
  notes: string;
  items: StanjeRobeStockOutRecord[];
  totalM2: number;
};

export const groupStockOutShipments = (records: StanjeRobeStockOutRecord[]): StanjeRobeShipmentGroup[] => {
  const map = new Map<string, StanjeRobeShipmentGroup>();
  for (const record of records) {
    const key = record.shipmentId || record._id;
    let group = map.get(key);
    if (!group) {
      group = {
        key,
        shipmentId: record.shipmentId,
        outDate: record.outDate,
        customerName: record.customerName || '-',
        notes: record.notes || '',
        items: [],
        totalM2: 0
      };
      map.set(key, group);
    }
    group.items.push(record);
    group.totalM2 += Number(record.squareMeters || 0);
  }
  return Array.from(map.values()).sort(
    (a, b) => new Date(b.outDate).getTime() - new Date(a.outDate).getTime()
  );
};

export const newShipmentLineKey = () => `line-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
